import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styled, { css } from "styled-components";

const SliderCustom = ({
  children,
  dots = true,
  length = 999,
  onLastChild = () => { },
  onChangeIndex = () => { },
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const slickRef = useRef();

  const settings = {
    dots,
    accessibility: false,
    arrows: false,
    infinite: false,
    initialSlide: currentIndex,
    appendDots: dots => (
      <div>
        <div id="dots" style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          margin: "20px 0px 20px 0px",
        }}> {dots} </div>
      </div>
    ),
    customPaging: i => (
      <CSquare index={i} goTo={() => slickRef.current?.slickGoTo(i)}>
        <Dot />
      </CSquare>
    ),

    afterChange: (index) => {
      if (index === length - 1) onLastChild();
      setCurrentIndex(index);
    },
  };

  useEffect(() => {
    if (length === 1) onLastChild();
  }, [length]);

  useEffect(() => {
    onChangeIndex(currentIndex);
  }, [currentIndex]);

  return (
    <Container dots={dots}>
      <Slider ref={slickRef} {...settings}>{children}</Slider>
    </Container>
  );
};

const CSquare = ({ index, goTo, children, ...rest }) => {

  const actionRef = useRef(undefined);

  return (
    <Square
      onTouchStart={() => {
        actionRef.current = goTo;
      }}
      onTouchMove={() => {
        actionRef.current = undefined;
      }}
      onTouchEnd={() => {
        if (actionRef.current !== undefined) actionRef.current();
      }}
      {...rest}
    >
      {children}
    </Square>);
}

const Dot = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 100%;
  background-color: #2480AB;
`;

const Square = styled.div`
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 2px;
  user-select: none;

  &:active {
    ${Dot} {
      background-color: #113D52;
    }
  }
`;



const Container = styled.div`
  .slick-dots {
    bottom: 0px;
    left: 0px;
    right: 0px;
    top: 0px;
    margin: 0px;
    position: relative;
    padding: 0px;
  }

  .slick-dots li {
    position: static;
    display: list-item;
    width: auto;
    height: auto;
    margin: 0;
  }

  .slick-track {
    display: flex;
    align-items: center;
  }

  #dots .slick-active div div {
    background-color: #16506B;
  }

`;

export default SliderCustom;
